import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  const links = t("footer.links.items", { returnObjects: true }) || [];
  const programs = t("footer.about.programs", { returnObjects: true }) || [];
  return (
    <footer className="bg-dark text-light pt-5">
      <Container>
        <Row className="gy-4">
          {/* About */}
          <Col xs={12} sm={6} md={3}>
            <h6 className="fw-bold mb-3 text-uppercase">
              {t("footer.about.title")}
            </h6>
            <p className="small text-light">{t("footer.about.description")}</p>
            <ul>
              {programs.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          </Col>

          {/* Useful Links / Services */}
          <Col xs={12} sm={6} md={3}>
            <h6 className="fw-bold mb-3 text-uppercase">
              {t("footer.links.title")}
            </h6>
            <ul className="list-unstyled small">
              {Array.isArray(links) &&
                links.map((link, index) => (
                  <li className="mb-2" key={index}>
                    <a
                      href={link.href}
                      className="text-light"
                      style={{ textDecoration: "none" }}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
            </ul>
          </Col>

          {/* Contact */}
          <Col xs={12} sm={6} md={3}>
            <h6 className="fw-bold mb-3 text-uppercase">
              {t("footer.contact.title")}
            </h6>
            <ul className="list-unstyled small">
              <li className="mb-2">{t("footer.contact.address")}</li>
              <li className="mb-2">
                <a
                  href={`tel:${t("footer.contact.phone")}`}
                  className="text-light"
                >
                  {t("footer.contact.phone")}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${t("footer.contact.email")}`}
                  className="text-light"
                >
                  {t("footer.contact.email")}
                </a>
              </li>
              <li className="mt-2" style={{whiteSpace: "pre-line"}}>
                <strong>{t("footer.contact.hoursLabel")}</strong>{" "}
                {t("footer.contact.hours")}
              </li>
            </ul>
          </Col>

          {/* Location / Map */}
          <Col xs={12} sm={6} md={3} className="mb-5">
            <h6 className="fw-bold mb-3 text-uppercase">
              {t("footer.location.title")}
            </h6>
            <div className="bg-secondary rounded p-2">
              <iframe
                title={t("footer.location.title")}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d682.8703342913051!2d-71.27425522516435!3d46.7948236165604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cb896e507dacfbf%3A0x1c3ce04c2ca0b049!2s2065%20Rue%20Frank-Carrel%2C%20Qu%C3%A9bec%2C%20QC%20G1N%202G1%2C%20Canada!5e0!3m2!1sfr!2stn!4v1768756780690!5m2!1sfr!2stn"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                style={{ width: "100%", height: "200px", border: 0 }}
              />
            </div>
          </Col>
        </Row>

        {/* Bottom bar */}
        <div className="border-top border-secondary mt-4">
          <Container>
            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center py-3">
              <small className="text-light text-center">
                {t("footer.bottomBar")}
              </small>
            </div>
          </Container>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
